import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { DOWNLOAD_STORAGE_KEY } from '@/components/FastCheckoutModal/constants';
import {
	FEATURE_NAMES,
	useIsCollaborator,
	useIsFeatureBlocked
} from '@/hooks/user';
import Remove from '@/icons/delete.svg';
import Folder from '@/icons/folder.svg';
import Mail from '@/icons/mail.svg';
import Print from '@/icons/print.svg';
import Share from '@/icons/share.svg';
import { storage } from '@/utils/browser';

import SaveToFolderModal from './SaveToFolderModal';
import SendDocumentModal from './SendDocumentModal';
import { PrintDocument, RemoveDocument, ShareDocument } from './modals';

export function useOptions() {
	const { t } = useTranslation();
	const [openOption, setOpenOption] = useState(null);
	const IS_FEATURE_BLOCKED = useIsFeatureBlocked();
	const isCollaborator = useIsCollaborator();

	const defaultOptions = [
		{
			name: FEATURE_NAMES.PRINT,
			label: t('common.print'),
			Component: PrintDocument,
			Icon: Print
		},
		{
			name: FEATURE_NAMES.SEND,
			label: t('myDocuments.table.dropdown.sendByEmail'),
			Component: SendDocumentModal,
			Icon: Mail
		},
		{
			name: FEATURE_NAMES.SHARE,
			label: t('common.share'),
			Icon: Share,
			Component: ShareDocument
		},
		{
			name: FEATURE_NAMES.SAVE,
			label: t('myDocuments.table.dropdown.saveToFolder'),
			Icon: Folder,
			Component: SaveToFolderModal
		},
		{
			name: FEATURE_NAMES.DELETE,
			label: t('common.delete'),
			Component: RemoveDocument,
			Icon: Remove
		}
	];

	const optionsCollaborator = defaultOptions.filter(
		({ name }) => name !== FEATURE_NAMES.DELETE
	);
	const options = isCollaborator ? optionsCollaborator : defaultOptions;

	const paidOptions = [
		FEATURE_NAMES.PRINT,
		FEATURE_NAMES.SAVE,
		FEATURE_NAMES.SEND,
		FEATURE_NAMES.SHARE
	];
	const isPaidOption = paidOptions.includes(openOption);

	const shouldOpenOption = optionName => {
		if (paidOptions.includes(optionName)) {
			return openOption === optionName && !IS_FEATURE_BLOCKED[optionName];
		}
		return openOption === optionName;
	};

	return {
		isPaidOption,
		options,
		openOption,
		paidOptions,
		setOpenOption,
		shouldOpenOption
	};
}

export function usePendingDownload({ id }) {
	const pendingDownloadId = storage.get(DOWNLOAD_STORAGE_KEY);

	const clearPending = () => {
		storage.remove(DOWNLOAD_STORAGE_KEY);
	};

	return { defaultDownloadOpen: pendingDownloadId === id, clearPending };
}
